// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-image-viewer__next, .el-image-viewer__prev, .el-image-viewer__close {\n  overflow: auto;\n  background-color: #4e4f50;\n}\n", ""]);
// Exports
module.exports = exports;
